/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './Promotion-Actions';

const promoInit = {
    affiliatePartner: '',
    bannerCodesAttempted: [],
    isPromotionAPILoading: '',
};

const promotionReducer = (state = promoInit, action) => {
    switch (action.type) {
        case actions.clearPromotionData().type:
            return promoInit;
        case actions.setMfeBannerCodesAttempted().type:
            return {
                ...state,
                bannerCodesAttempted: action?.data || [],
            };
        case actions.mfeRedirectToPromoAffiliate().type:
            return {
                ...state,
                affiliatePartner: {
                    name: action.data.promoAffiliate,
                    affiliateURL: action.data.affiliateURL,
                },
            };
        case actions.mfeClearPromoAffiliate().type:
            return {
                ...state,
                affiliatePartner: {
                    name: '',
                    affiliateURL: '',
                },
            };
        case actions.mfeApplyPromotionIsLoading().type:
            console.log('isPromotionAPILoading', action.payload);
            return {
                ...state,
                isPromotionAPILoading: action.payload,
            };
        default:
            return state;
    }
};

export default promotionReducer;
